export default (node) => {
  /**
   * Data + elements
   */
  const allTitles = node.querySelectorAll('[data-menu-main-title-mega]');
  const allMegaMenus = node.querySelectorAll('[data-mega-menu-end]');
  /**
   * Functions
   */
  const openMegaMenu = (mainTitle) => {
    allMegaMenus.forEach((oneMegaMenu) => {
      if (oneMegaMenu.getAttribute('data-mega-menu-end') === mainTitle) {
        oneMegaMenu.classList.remove('hidden');
      } else {
        oneMegaMenu.classList.add('hidden');
      }
    });
  };

  const closeMegaMenu = () => {
    allMegaMenus.forEach((oneMegaMenu) => {
      oneMegaMenu.classList.add('hidden');
    });
  };
  /**
   * Init
   */
  const init = () => {
    allTitles.forEach((oneTitle) => {
      oneTitle.addEventListener('mouseenter', (e) => {
        const element = e.currentTarget;
        openMegaMenu(element.getAttribute('data-menu-main-title-mega'));
      });
    });

    document.addEventListener('desktop-menu-mega:close', closeMegaMenu);
  };

  init();
};
